import packageView from './package';
import { Package } from '@/models/package';

export default class IView extends packageView {
  public Name = 'package-hardware';

  public Filter(v: Package) {
    return v.interval === 'once' || v.category === 'shipping';
  }
}
